module.exports = __webpack_public_path__ + "static/media/cu07_ch01.46b24dd8.png";